export const STAGE_KEY = 'nurturing';

export const STAGE_CONFIG = {
  id: 'fase3',
  label: 'Nutricion estrategica',
  questionOrder: [
    'requestedService',
    'prospectos',
    'ticket',
    'productionCost',
    'newClients',
    'closeRate',
    'marketingPercent',
    'presupuestoMesa',
    'userEmail',
    'userPhone',
  ],
  coreFields: [
    'requestedService',
    'presupuestoMesa',
    'ticket',
    'productionCost',
    'newClients',
    'closeRate',
    'userEmail',
    'userPhone',
  ],
  serviceIds: ['nutri-mapa', 'nutri-email', 'nutri-score', 'nutri-whatsapp', 'nutri-recuperacion', 'nutri-followup'],
  questions: {
    requestedService: '¡Mucho gusto, {userName}! Para su estrategia de nutricion, ¿que buscamos mejorar hoy: sus correos, automatizar WhatsApp o poner orden con un CRM?',
    prospectos: '¿Y hoy por donde le llegan y donde los esta atendiendo: WhatsApp, CRM, o los lleva de forma manual en Excel?',
    ticket: 'Para dimensionar bien esta nutricion, ¿cual es el valor promedio de ese cliente ({offer}) que estamos intentando cerrar?',
    productionCost: '¿And quanto le cuesta a nivel operativo entregar el servicio una vez que le dicen que si?',
    newClients: '¿Cuantas ventas extra al mes le gustaria estar rescatando con un seguimiento mas inteligente y automatizado?',
    closeRate: 'De los que le contactan hoy, ¿que porcentaje termina comprando realmente? Necesito este dato para calcular el impacto de la mejora.',
    marketingPercent: '¿Que parte de ese margen siente que puede reinvertir para que la maquina de seguimiento funcione sola?',
    presupuestoMesa: '¿Con que presupuesto mensual cuenta para implementar esta mejora operativa?',
    userEmail: 'Ya casi terminamos. Para mandarle su análisis detallado, ¿a qué correo se lo comparto?',
    userPhone: 'Y por si se corta la conexión antes de darle sus resultados, ¿cuál es su WhatsApp o número de contacto?',
  },
};

const nurturingGuide = {
  role: 'Asesor de maduracion y seguimiento.',
  detectWhen: [
    'El usuario pide correos, WhatsApp, seguimiento, CRM o recuperar leads.',
  ],
  firstQuestions: [
    'Que busca exactamente: correos, WhatsApp, CRM, nutricion o recuperacion?',
  ],
  thenAsk: [
    'Donde hace el seguimiento hoy (WhatsApp, Excel, CRM)?',
    'Que porcentaje de cierre tiene actualmente?',
    'Cuantos cierres extra le gustaria rescatar con automatizacion?',
    'Con cuanto presupuesto real cuenta para esta mejora operativa?',
  ],
  avoidForNow: [
    'No preguntes branding si el usuario ya viene con base montada y pide seguimiento.',
  ],
  mustExplain: [
    'Esta etapa convierte interes frio en conversaciones mas maduras y ordenadas.',
  ],
  services: [
    'Mapa de nutricion por etapas',
    'Secuencias de email marketing',
    'Calificacion de oportunidades',
    'Secuencias por WhatsApp',
    'Recuperacion de leads frios',
    'Seguimiento inteligente multicanal',
  ],
};

export default nurturingGuide;
